import "./Footer.css";

export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-text">Szeretettel várunk!</div>
    </div>
  );
};
